import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthProvider";

function SearchAndAddProductBar({ setSearchValue, searchValue = "" }) {
  const navigate = useNavigate();
  const { t } = useTranslation("productlist");
  const { userRole } = useAuth();

  return (
    <div className="flex justify-between items-center mb-3">
      <div className="bg-white rounded-lg px-4 py-[5px] flex items-center gap-2 w-[305px] h-[50px]">
        <img
          className="fill-text-dark"
          src="/search-normal.svg"
          alt={t("searchAndAddProductBar.alt.search")}
        />
        <input
          type="text"
          value={searchValue}
          placeholder={t("searchAndAddProductBar.placeholder")}
          className="w-full p-[10px] border-none text-[16px] font-normal leading-6 text-text-dark focus:outline-none"
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>
      {/*  align buttons to the end and handle rtl */}
      {userRole !== 'viewer' && (
        <div className="flex gap-2 ml-auto rtl:ml-0 rtl:mr-auto">
          <button
            className="bg-white text-[#5507CF] border border-[#5507CF] px-[16px] py-[12px] rounded-[12px] cursor-pointer text-base font-semibold leading-[19.36px] h-[48px] flex gap-[8px] items-center"
            onClick={() => navigate("/products/bulk-upload")}
          >
            <img
              src="/bulk-upload.svg"
              alt={t("searchAndAddProductBar.alt.bulkUpload")}
            />
            {t("searchAndAddProductBar.bulkUploadButton")}
          </button>

          <button
            className="bg-[#5507cf] text-white border-none p-3 rounded-lg cursor-pointer text-base font-semibold leading-[19.36px] h-[44px] flex gap-2 items-center"
            onClick={() => navigate("/products/add-new-product")}
          >
            <img src="/add.svg" alt={t("searchAndAddProductBar.alt.add")} />
            {t("searchAndAddProductBar.addButton")}
          </button>
        </div>
      )}
    </div>
  );
}

export default SearchAndAddProductBar;
